import { If, UnderlineText } from 'aa_common/front-end/components'
import { isEmptyValue } from 'aa_common/front-end/helpers'
import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { getNs } from 'common/i18n-config'
import { LedgerSettingsItem } from 'common/models'
import Form from 'components/molecules/Form'

import { useGetAssetLedger } from '../hooks/use-get-asset-ledger'
import { useGetDepreciation } from '../hooks/use-get-depreciation'
import { useIsFullImpairment } from '../hooks/use-is-full-impairment'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment', 'common'])
const { FormField } = Form

type DepreciationRateProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const DepreciationRate = ({ ledgerSetting }: DepreciationRateProps) => {
  useNsReady()

  const assetLedger = useGetAssetLedger(ledgerSetting)
  const disabled = useIsFullImpairment()

  const shouldShow =
    !!assetLedger?.depreciation_method_code &&
    [
      DEPRECIATION_METHOD_CODE.OLD_DECLINING_BALANCE,
      DEPRECIATION_METHOD_CODE.NEW_DECLINING_BALANCE_250,
      DEPRECIATION_METHOD_CODE.NEW_DECLINING_BALANCE_200,
      DEPRECIATION_METHOD_CODE.DECLINING_BALANCE_AFTER_IMPAIR,
    ].includes(assetLedger?.depreciation_method_code)

  const depreciationRate = useGetDepreciation(shouldShow, assetLedger?.ledger_setting_id)

  return (
    <If condition={shouldShow}>
      <FormField title={t('depreciation_rate')} disabled={disabled}>
        <If condition={disabled}>
          <span className="disabled-content">ー</span>
        </If>
        <If condition={!disabled}>
          <UnderlineText>{!isEmptyValue(depreciationRate) ? `${depreciationRate}` : ''}</UnderlineText>
        </If>
      </FormField>
    </If>
  )
}
